import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { Alert, Badge, Button, Form } from "react-bootstrap";
import Loading from "../../../components/Loading";
import { useFormActaStore } from "../../../store/formActaStore";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import "./style.css";

import "leaflet/dist/leaflet.css";
import useWindowSize from "../../../hooks/useWindowSize";
import ViewMap from "../../../components/ViewMap";
import { getPodadoresHandler } from "../../../handlers/podadores.handler";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import ModalPodadores from "../../../screens/Public/Actas/components/ModalPodadores";
import ModalFinalizarActa from "../../../screens/Public/Actas/components/ModalFinalizarActa";
import StarDisplay from "../../../components/StarDisplay";
import ModalCancelarActa from "../../../screens/Public/Actas/components/ModalCancelarActa";
import DatosPersonalesGeneral from "./components/DatosPersonalesGeneral/DatosPersonalesGeneral";
import TabsDatosPersonales from "./components/TabDatosPersonales/TabDatosPersonales";
import { useLocation, useNavigate } from "react-router-dom";
import AlertEstadoSolicitud from "./components/AlertEstadoSolicitud/AlertEstadoSolicitud";
import ArrowDown from "../../../components/svgs/ArrowDown";
import ArrowUp from "../../../components/svgs/ArrowUp";
import ArrowIzquierdoIcon from "../../../components/svgs/ArrowIzquierdoIcon";

const FormActa4 = () => {
  const { modals, handlerModal, loads } = useGeneralAppStore();
  const size = useWindowSize();
  const { width } = size;
  const { loading, setLoading, setUltimoPaso, acta_id, defaultValues, setFormActive, setRefetch } =
    useFormActaStore();
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [previews, setPreviews] = useState([]);
  const [zoomStyle, setZoomStyle] = useState({});
  const [verConstatacion, setVerConstatacion] = useState(false);
  const nav = useNavigate();

  const path = useLocation()?.pathname;

  const handleMouseMove = (e) => {
    const { offsetX, offsetY, target } = e.nativeEvent;
    const { width, height } = target;

    const xPos = (offsetX / width) * 100;
    const yPos = (offsetY / height) * 100;

    setZoomStyle({
      transform: `scale(1.5)`,
      transformOrigin: `${xPos}% ${yPos}%`,
    });
  };

  const handleMouseLeave = () => {
    setZoomStyle({
      transform: "scale(1)",
    });
  };

  useEffect(() => {
    if (previews.length > 0) {
      setImagePreviewUrl(previews[0]);
    }
  }, [previews]);

  useEffect(() => {
    if (defaultValues?.archivos) {
      const basesPreviews = defaultValues?.archivos.map((img) => {
        return img.base64.file;
      });
      setPreviews(basesPreviews);
    }
  }, []);

  return (
    <>
      <motion.div
        key="form"
        initial={{ opacity: 0 /* , x: 100 */ }}
        animate={{ opacity: 1 /* , x: 0  */ }}
        exit={{ opacity: 0 /* , x: -100 */ }}
        transition={{ /* delay: 0.5, */ delay: 1, duration: 0.5 }}
        className="w-100 "
      >
        {loads.includes("get_podadores") && (
          // <div className='position-absolute w-100 h-100 d-flex justify-content-center align-items-center' style={{ backgroundColor: "rgba(255,255,255,0.8)", zIndex: "999" }}>
          <div
            className="position-fixed top-0   w-100 h-100 d-flex justify-content-center align-items-center p-0 "
            style={{ backgroundColor: "rgba(255,255,255,0.8)", zIndex: "9999", left: "0" }}
          >
            <Loading font="16px" sizeIcono="50px" sizeLoad="70px" />
          </div>
        )}
        <form className="col-12 mx-auto ">
          <div className={` mb-4${width >= 640 ? "" : ""} `}>
            <AlertEstadoSolicitud
              estado={defaultValues.estado}
              podadores={defaultValues.podadores}
            />
            {defaultValues?.podadores?.length > 0 && (
              <div className={`${width < 480 ? "" : "px-3"}`}>
                <hr />
                <h5 className="">Podadores seleccionados</h5>
                {defaultValues?.podadores.map((podador) => {
                  return (
                    <div key={podador.id}>
                      <div className={`d-flex gap-1`} style={{ fontSize: width < 640 && 13 }}>
                        <PhoneEnabledIcon sx={{ width: "16px" }} /> <b>{podador.telefono}</b>
                        <span className="fw-bold text-primary"> / </span>
                        <span
                          className="d-flex gap-2 align-items-center"
                          style={{ lineHeight: "8px" }}
                        >
                          {podador.nombre}
                        </span>
                        <span className="fw-bold text-primary"> / </span>
                        <StarDisplay rating={podador?.puntuacion?.puntuacion} />
                      </div>
                    </div>
                  );
                })}
                <hr />
              </div>
            )}
          </div>

          {defaultValues?.constatacion && (
            <div className={`${width >= 640 ? "" : ""}`}>
              <div>
                <p
                  onClick={() => {
                    setVerConstatacion(!verConstatacion);
                  }}
                  style={{ cursor: "pointer" }}
                  className="m-0 bg-primary w-100 px-4 py-2 text-white d-flex justify-content-between"
                >
                  Detalle de la constatación
                  {verConstatacion ? <ArrowUp color="#fff" /> : <ArrowDown color="#fff" />}
                </p>
              </div>
              <motion.div
                initial={{ minHeight: 0, opacity: 0 }}
                animate={{
                  minHeight: !verConstatacion ? 0 : "auto",
                  opacity: verConstatacion ? 1 : 0,
                }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                className={`${
                  verConstatacion && "p-3"
                } d-flex  mx-auto d-flex mb-1 border border-1 border-[#AAA] rounded-b-xl border-t-0`}
                style={{ width: "100%" }}
              >
                {verConstatacion && (
                  <section className={` w-100 d-flex ${width < 992 && "flex-column"}`}>
                    <div
                      className={`${width >= 992 ? "col-6" : "col-12"} d-flex flex-column gap-4`}
                    >
                      <p className="m-0 text-primary fw-bold ">
                        <h5 className="text-dark mb-0">Datos de la constatación</h5>
                        <hr className="mb-3 mt-1 text-dark" />
                        Número de acta:{" "}
                        <span className="fw-medium text-dark">
                          {defaultValues?.constatacion?.numero_acta}
                        </span>
                      </p>
                      <p className="m-0 text-primary fw-bold d-flex flex-column">
                        Observacion:{" "}
                        <span className="fw-medium text-dark">
                          {defaultValues?.constatacion?.observacion}
                        </span>
                      </p>
                      <p className="m-0 text-primary fw-bold d-flex flex-column">
                        Constatacion de daños:{" "}
                        <span className="fw-medium text-dark">
                          {defaultValues?.constatacion?.constatacion_dano}
                        </span>
                      </p>
                      <p className="m-0 text-primary fw-bold d-flex flex-column">
                        Descripción tarea:{" "}
                        <span className="fw-medium text-dark">
                          {defaultValues?.constatacion?.descripcion_tarea}
                        </span>
                      </p>
                    </div>
                    {width < 992 && <hr />}
                    <div>
                      {width < 992 && (
                        <p className="m-0 text-primary fw-bold d-flex flex-column">
                          Acta de constatacion:
                        </p>
                      )}
                      <div
                        className={`${width >= 992 ? "col-6" : "col-12"} d-flex flex-column w-100`}
                        style={{ background: "#28252A" }}
                      >
                        <img
                          src={defaultValues?.constatacion?.constatacion_file?.base64?.file}
                          alt="img-constatacion"
                          className="w-100 object-fit-contain"
                          style={{ aspectRatio: "3/4" }}
                        />
                      </div>
                    </div>
                  </section>
                )}
              </motion.div>
            </div>
          )}

          <div
            className={` d-flex gap-4 align-item-start   justify-content-center   mx-auto justify-content-between ${
              width >= 640 ? "col-12 py-4 px-2" : "col-12 flex-wrap"
            }`}
            // style={{ minHeight: "280px" }}
          >
            {/* {width <= 640 && <TabsDatosPersonales />} */}
            {/* {width > 640 && <DatosPersonalesGeneral />} */}
            <DatosPersonalesGeneral />
          </div>

          <hr />
          <section
            className={`d-flex  gap-4 ${
              width > 992 ? "mt-3  col-12" : "flex-wrap "
            }   mx-auto align-items-start`}
          >
            {defaultValues?.latitud && defaultValues?.longitud && (
              <>
                <div className={`${width > 992 ? "col-5" : "col-12"}`}>
                  <h5 className="text-dark">Ubicación</h5>
                  <div
                    className="w-100"
                    style={{ height: width > 992 ? "310px" : "200px", border: "2px solid #1134C9" }}
                  >
                    {defaultValues && (
                      <ViewMap center={[defaultValues?.latitud, defaultValues?.longitud]} />
                    )}
                  </div>
                </div>
              </>
            )}

            {defaultValues.archivos?.length > 0 && (
              <section
                className={`col  d-flex ${
                  width <= 992 ? "flex-column-reverse" : "justify-content-center"
                } `}
              >
                <div
                  className={` border border-2 rounded d-flex    gap-3 justify-content-start p-2 ${
                    width <= 992 ? "overflow-x-scroll w-100" : "overflow-y-scroll flex-column"
                  } `}
                  style={{ width: "75px", aspectRatio: width <= 992 ? "" : "3/4" }}
                >
                  {previews.map((imagen, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          aspectRatio: width <= 992 ? "3/4" : "9/16",
                          border:
                            imagePreviewUrl == imagen ? "2px solid #1134C9" : "2px solid #c9c9c9",
                          cursor: "pointer",
                          overflow: "hidden",
                          height: width <= 992 && "20px",
                          minHeight: "55px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        className=" d-flex flex-column justify-content-center align-items-center"
                        onClick={() => {
                          setImagePreviewUrl(imagen);
                        }}
                      >
                        <img
                          key={index}
                          src={imagen}
                          alt="img-prev"
                          style={{
                            cursor: "pointer",
                            objectFit: "contain",
                            backgroundColor: "#c9c9c9",
                            height: "100%",
                            width: "100%",
                          }}
                          onClick={() => {
                            setImagePreviewUrl(imagen);
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
                <div
                  className=""
                  style={{
                    overflow: "hidden",
                    aspectRatio: "3/4",
                    // height: width <= 992 ? "390px" : "350px",
                    height: "350px",
                    backgroundColor: "#28252A",
                  }}
                >
                  {imagePreviewUrl && (
                    <img
                      src={imagePreviewUrl}
                      alt="img-select"
                      className="w-100 h-100 zoom-image"
                      style={{ ...zoomStyle, objectFit: "contain" }}
                      onMouseMove={handleMouseMove}
                      onMouseLeave={handleMouseLeave}
                    />
                  )}
                </div>
              </section>
            )}
          </section>
        </form>
        {![3, 8, 2].some((estado) => estado == defaultValues?.estado?.id) && (
          <Alert variant="danger" className="m-0 d-flex flex-column align-items-center gap-2 mt-5">
            Si desea rechazar la solicitud, haga click en "Rechazar".
            <Button
              variant="danger"
              size="sm"
              onClick={() => handlerModal({ modal: true, modalName: "cancelar_acta" })}
            >
              Rechazar
            </Button>
          </Alert>
        )}
        <hr />
        <div>
          {defaultValues.estado.id == 2 && defaultValues?.podadores?.length > 0 && (
            <div className="d-flex justify-content-center mb-4 mt-4">
              <Button
                variant="success"
                size="sm"
                onClick={() => handlerModal({ modal: true, modalName: "finalizar_acta" })}
              >
                Finalizar solicitud
              </Button>
            </div>
          )}
          <div
            className={`d-flex gap-4 ${
              defaultValues.estado.id == 2 && defaultValues?.podadores?.length > 0 ? "pb-5" : "py-5"
            }  justify-content-center align-items-center`}
          >
            <Button size="sm" onClick={() => nav("/")}>
              {" "}
              <ArrowIzquierdoIcon width={20} height={20} color="#fff" /> Volver al menu
            </Button>
            <Button
              size="sm"
              onClick={() => {
                if (path == "/mis_solicitudes") {
                  setFormActive(false);
                  setRefetch(true);
                }
                if (path == "/crear_solicitud") {
                  console.log("entre");
                  nav("/mis_solicitudes");
                }
              }}
            >
              {" "}
              <ArrowIzquierdoIcon color="#fff" width={20} height={20} /> Ver mis solicitudes
            </Button>
          </div>
        </div>
      </motion.div>
      {/* )} */}
      {modals.includes("cancelar_acta") && <ModalCancelarActa actaId={defaultValues?.id} />}
      {modals.includes("podadores") && <ModalPodadores />}
      {modals.includes("finalizar_acta") && <ModalFinalizarActa />}
    </>
  );
};
export default FormActa4;
